export default "__VITE_ASSET__L7UDEt2X__"